var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, Flex, media, prop } from '@creditas-ui/react';
var DialogElement = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: 100%;\n  background-color: ", ";\n  box-sizing: border-box;\n  flex-direction: column;\n\n  border-radius: ", ";\n\n  ", " {\n    width: ", "px;\n  }\n"], ["\n  width: ", ";\n  height: 100%;\n  background-color: ", ";\n  box-sizing: border-box;\n  flex-direction: column;\n\n  border-radius: ", ";\n\n  ", " {\n    width: ", "px;\n  }\n"])), function (_a) {
    var rounded = _a.rounded;
    return (rounded ? 'calc(100vw - 32px)' : '100vw');
}, prop('theme.colors.neutral.0'), function (_a) {
    var rounded = _a.rounded;
    return (rounded ? '16px' : '0');
}, media.up('4xl'), function (_a) {
    var width = _a.width;
    return width !== null && width !== void 0 ? width : 576;
});
export { DialogElement };
var templateObject_1;
//# sourceMappingURL=Dialog.style.js.map